function CollapseDetails({ object, onDelete, onEdit }) {
  return (
    <div className="d-flex flex-column gap-1">
      <div className="d-flex gap-1">
        <label className="fw-bold text-muted">TIN :</label>
        <p className="m-0">{object?.supplier?.tinNo || "N/A"}</p>
      </div>

      <div className="d-flex gap-1">
        <label className="fw-bold text-muted">VAT Value :</label>
        <p className="m-0">&#8369; {object?.vat}</p>
      </div>

      <div className="d-flex gap-1">
        <label className="fw-bold text-muted">Net Value :</label>
        <p className="m-0">&#8369; {object?.net}</p>
      </div>

      <div className="d-flex gap-2 mt-2">
        <button
          className="btn text-white px-2 bg-primary fw-bold"
          onClick={() => onEdit(object)}
        >
          <i className="bi bi-pencil me-2"></i>
          Edit
        </button>
        <button
          className="btn btn-danger px-2 bg-error fw-bold"
          onClick={() => onDelete(object.id)}
        >
          <i className="bi bi-trash me-2"></i>
          Delete
        </button>
      </div>
    </div>
  );
}

export default CollapseDetails;
